import { render, staticRenderFns } from "./FileList.vue?vue&type=template&id=af63648c&"
import script from "./FileList.vue?vue&type=script&lang=ts&"
export * from "./FileList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports